var _animate, _animateTransform, _animateTransform2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 841.89 595.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M165.46,145.13l66.89-47.71,74.86-47.91s28.41-14.29,57.26-12.26,42.25,3.2,56,7.9l98.24,40.26S603.58,124.17,612,130s20.41,12.15,25.21,24.38,3.58,83.69,3.58,83.69l-2.09,35.48s-2,16.75-20.9,29.6L484.05,394.3S453,413.78,417.67,413.6s-54.13-5.17-69.92-12.21L178.72,326s-19-7.45-28.26-20.22-8.24-17.61-8.24-17.61l-1.15-37,3.18-72.81s.13-11.07,7.45-19.42A142.3,142.3,0,0,1,165.46,145.13Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "bevel",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.35,97.42s19.13,2.51,33.57,7.76,77.92,32.57,85.25,35.57,19.62,8.07,26.17,9.72a140.07,140.07,0,0,0,15.11,2.64s1.43,3.22,14.36,10.41,48.85,23.92,65.67,31.71,38.14,16.92,54.19,27.29S552,240,552,240",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.3,258.55s68.67-69,127.15-105.44,93.34-58.86,126.08-67.68",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.75,167.06s-12.21,29,22.28,49l181.3,82.59s24.07,13.75,67.33,10.91S485,288.87,485,288.87l134.47-92.14s18.43-12.41,19.86-27.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.64 221.82 178.72 325.97 347.75 401.38 350.33 298.67 180.64 221.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.99 288.87 484.05 394.3 617.79 303.17 619.46 196.73 484.99 288.87",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,256.26s2.86,21.39,37.87,36.64,169.25,75.67,169.25,75.67,75.77,27.48,135.47-6.83l57.31-38.55,2.92,1.51,17.11-11.26,2.67-6.16,54.24-37A177,177,0,0,0,632.57,257c5.41-5.94,7.59-15.29,7.59-15.29",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.07,251.14s12,28.29,38.38,35.12l169.27,76.5s77.94,28.1,135.33-6.85l56.17-37.26,1.41-5.71,20.65-12.67,1.48,2.73,54-37.09a64.22,64.22,0,0,0,23-27.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.86,178.43a6.14,6.14,0,0,0,1.36.55,7.83,7.83,0,0,0,1.51.26,5,5,0,0,0,2.62-.47,1.88,1.88,0,0,0,.71-.65,1.18,1.18,0,0,0,.13-.82,2.7,2.7,0,0,0-1.45-1.62,7.07,7.07,0,0,0-2.87-.79,6.26,6.26,0,0,0-1.45.08,3.74,3.74,0,0,0-1.17.39,1.39,1.39,0,0,0-.84,1.47A2.66,2.66,0,0,0,588.86,178.43Z",
    style: {
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595,172.32a6.13,6.13,0,0,0,1.36.54,7.31,7.31,0,0,0,1.53.26,5.16,5.16,0,0,0,2.64-.44,1.9,1.9,0,0,0,.72-.64,1.12,1.12,0,0,0,.13-.8,2.69,2.69,0,0,0-1.46-1.6,7.38,7.38,0,0,0-2.9-.79,6.33,6.33,0,0,0-1.46.07,3.49,3.49,0,0,0-1.18.38,1.33,1.33,0,0,0-.85,1.43A2.69,2.69,0,0,0,595,172.32Z",
    style: {
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.72,151.1a7.1,7.1,0,0,0,1.41.52,8.17,8.17,0,0,0,1.56.24,5.58,5.58,0,0,0,2.68-.4,1.81,1.81,0,0,0,.72-.59,1,1,0,0,0,.13-.74,1.69,1.69,0,0,0-.48-.79,3.72,3.72,0,0,0-1-.7,7.79,7.79,0,0,0-3-.77,6.52,6.52,0,0,0-1.48,0,4.25,4.25,0,0,0-1.2.35,1.74,1.74,0,0,0-.72.59.93.93,0,0,0-.14.74,2.64,2.64,0,0,0,1.5,1.5",
    style: {
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.46,143.68a7,7,0,0,0,1.4.51,8.31,8.31,0,0,0,1.56.25,5.56,5.56,0,0,0,2.68-.4,1.74,1.74,0,0,0,.72-.59.93.93,0,0,0,.14-.74,1.64,1.64,0,0,0-.48-.79,4.07,4.07,0,0,0-1-.71,8,8,0,0,0-3-.77,7.26,7.26,0,0,0-1.49.06,4,4,0,0,0-1.2.34,1.74,1.74,0,0,0-.72.59,1,1,0,0,0-.13.75,2.58,2.58,0,0,0,1.5,1.5",
    style: {
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.06,165.49a6.83,6.83,0,0,0,1.38.53,8.13,8.13,0,0,0,1.54.26,5.36,5.36,0,0,0,2.66-.43,1.75,1.75,0,0,0,.71-.62,1,1,0,0,0,.14-.78,2.65,2.65,0,0,0-1.48-1.56,7.6,7.6,0,0,0-2.92-.79,7.06,7.06,0,0,0-1.47.06,3.87,3.87,0,0,0-1.19.37,1.3,1.3,0,0,0-.85,1.4,2.64,2.64,0,0,0,1.48,1.56",
    style: {
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.4,159a7.16,7.16,0,0,0,1.39.53,8,8,0,0,0,1.54.26,5.3,5.3,0,0,0,2.65-.43,1.79,1.79,0,0,0,.72-.62,1.07,1.07,0,0,0,.14-.78,2.68,2.68,0,0,0-1.48-1.56,7.7,7.7,0,0,0-2.92-.79,7.16,7.16,0,0,0-1.48.06,3.9,3.9,0,0,0-1.18.37,1.31,1.31,0,0,0-.86,1.4A2.7,2.7,0,0,0,598.4,159",
    style: {
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.58,138a6.51,6.51,0,0,0,1.41.5,9.18,9.18,0,0,0,1.56.23,5.81,5.81,0,0,0,2.68-.4,1.72,1.72,0,0,0,.72-.58.87.87,0,0,0,.13-.72,1.52,1.52,0,0,0-.48-.76,3.71,3.71,0,0,0-1-.69,8.23,8.23,0,0,0-4.46-.69,4.28,4.28,0,0,0-1.19.35,1.72,1.72,0,0,0-.72.58.9.9,0,0,0-.13.73,2.55,2.55,0,0,0,1.5,1.45",
    style: {
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_remote_blink",
    attributeName: "fill",
    values: "#fff;#00ffdc;#fff",
    begin: "hinava_random_uuid_remote_go_out.end",
    end: "hinava_random_uuid_remote_go_out.end+4.2s;",
    dur: "0.7s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("polyline", {
    points: "560.77 432.06 523.91 432.06 523.91 338.68",
    style: {
      fill: "none",
      stroke: "#f26850",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.19,339.24a11.28,11.28,0,1,0-11.28,11.28A11.28,11.28,0,0,0,535.19,339.24Z",
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.26,451.52a73,73,0,0,0,.88,11.34,68.8,68.8,0,0,0,1.56,7.34A72.12,72.12,0,0,0,587.53,513c1.29.83,2.67,1.56,4.05,2.3,1.74.92,3.49,1.74,5.23,2.57,2.12.92,4.41,1.75,6.62,2.48,1.47.46,2.94.92,4.41,1.29a45,45,0,0,0,5.14,1.1,69.85,69.85,0,0,0,12.5,1.1c1.1,0,2.2,0,3.31-.09,1.47-.09,2.85-.18,4.32-.37l4.31-.55c1.2-.18,2.39-.46,3.5-.64a71.91,71.91,0,0,0,24.8-10.57c1.2-.82,2.39-1.65,3.5-2.57a73.12,73.12,0,0,0,22-27.33c.11-.23.22-.46.32-.69l.18-.4c.94-2.11,1.78-4.28,2.53-6.49.53-1.59,1-3.17,1.41-4.85l.06-.21a73.29,73.29,0,0,0,2.11-16.26v-1.29c0-.92,0-1.84-.09-2.75-.07-1.58-.18-3.16-.34-4.72a72.46,72.46,0,0,0-16.11-38.47l-.33-.4c-.64-.78-1.35-1.57-2.06-2.36q-2-2.2-4.21-4.25a72.44,72.44,0,0,0-29.54-16.64,72.41,72.41,0,0,0-19.72-2.72,67.89,67.89,0,0,0-14.34,1.47,24.85,24.85,0,0,0-3.49.83,71.6,71.6,0,0,0-13,4.68,72.15,72.15,0,0,0-41.3,65.33Z",
    style: {
      fill: "#fff",
      stroke: "#f26850",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.26,451.52a73,73,0,0,0,.88,11.34,68.8,68.8,0,0,0,1.56,7.34A72.12,72.12,0,0,0,587.53,513c1.29.83,2.67,1.56,4.05,2.3,1.74.92,3.49,1.74,5.23,2.57,2.12.92,4.41,1.75,6.62,2.48,1.47.46,2.94.92,4.41,1.29a45,45,0,0,0,5.14,1.1,69.85,69.85,0,0,0,12.5,1.1c1.1,0,2.2,0,3.31-.09,1.47-.09,2.85-.18,4.32-.37l4.31-.55c1.2-.18,2.39-.46,3.5-.64a71.91,71.91,0,0,0,24.8-10.57c1.2-.82,2.39-1.65,3.5-2.57a73.12,73.12,0,0,0,22-27.33c.11-.23.22-.46.32-.69l.18-.4c.94-2.11,1.78-4.28,2.53-6.49.53-1.59,1-3.17,1.41-4.85l.06-.21a73.29,73.29,0,0,0,2.11-16.26v-1.29c0-.92,0-1.84-.09-2.75-.07-1.58-.18-3.16-.34-4.72a72.46,72.46,0,0,0-16.11-38.47l-.33-.4c-.64-.78-1.35-1.57-2.06-2.36q-2-2.2-4.21-4.25a72.44,72.44,0,0,0-29.54-16.64,72.41,72.41,0,0,0-19.72-2.72,67.89,67.89,0,0,0-14.34,1.47,24.85,24.85,0,0,0-3.49.83,71.6,71.6,0,0,0-13,4.68,72.15,72.15,0,0,0-41.3,65.33Z",
    style: {
      fill: "none",
      stroke: "#f26850",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.79,451.52v1.29a73.21,73.21,0,0,1-2.11,16.26l-.06.21c-.44,1.68-.88,3.26-1.41,4.85-.75,2.21-1.59,4.38-2.53,6.49l-.18.4c-.1.23-.2.46-.31.69a73.33,73.33,0,0,1-22,27.33c-1.11.92-2.3,1.75-3.49,2.57a71.85,71.85,0,0,1-24.81,10.57c-1.11.18-2.3.46-3.49.64l-4.32.55c-1.47.19-2.85.28-4.32.37-1.1.09-2.21.09-3.31.09a69.85,69.85,0,0,1-12.5-1.1,45,45,0,0,1-5.14-1.1c-1.47-.37-2.94-.83-4.41-1.29-2.21-.73-4.5-1.56-6.62-2.48-1.74-.83-3.49-1.65-5.23-2.57-.84-.45-1.69-.9-2.51-1.38h0c-.52-.29-1-.6-1.53-.92a72,72,0,0,1-14.89-12.2,68.51,68.51,0,0,1-4.54-5.37c-.33-.43-.66-.87-1-1.31a1,1,0,0,1-.12-.17,71.68,71.68,0,0,1-10.69-21.59c-.21-.71-.42-1.43-.61-2.15a68.8,68.8,0,0,1-1.56-7.34,73,73,0,0,1-.88-11.34,72.2,72.2,0,0,1,2.11-17.39q.58-2.4,1.35-4.74c.13-.42.27-.84.41-1.26a72.35,72.35,0,0,1,37.43-41.93,70.88,70.88,0,0,1,13-4.69,24.66,24.66,0,0,1,3.5-.83,67.73,67.73,0,0,1,14.33-1.47c1,0,1.93,0,2.89.06l1.44.07a73.07,73.07,0,0,1,10.34,1.36q2.57.53,5.06,1.23A72.45,72.45,0,0,1,672,396.2c.92.77,1.81,1.56,2.69,2.37,1.46,1.36,2.86,2.79,4.2,4.26.71.78,1.42,1.57,2.06,2.35l.33.4a73,73,0,0,1,5.32,7.37l.12.18c.25.41.51.82.76,1.24a72.31,72.31,0,0,1,9.44,26.06h0c.19,1.19.34,2.4.47,3.61.17,1.57.28,3.14.34,4.72C697.79,449.69,697.79,450.6,697.79,451.52Z",
    style: {
      fill: "#fff",
      stroke: "#f26850",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.82,493.16c1.4-.81,2.76-1.65,4-2.51l.57-.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.69,413.13,654.9,434.82,651.74,437a0,0,0,0,1,0,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "568.1 495.42 568.67 495.11 573 492.36",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "628.6 454.66 628.6 454.63 628.59 454.59 628.58 454.57 628.56 454.55 628.54 454.54 628.51 454.54 628.49 454.55 628.46 454.57",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.52,419.2c10.56-7.94,21.37-15.8,32.52-23.71q11.37-8.07,23.24-16.22",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.13,428.13l1.15-.52c1.07-.5,2.13-1,3.16-1.55s2-1.06,3-1.61,1.92-1.1,2.84-1.68,1.82-1.15,2.7-1.75,1.7-1.21,2.54-1.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.31,472.35c1.29-.53,2.55-1.07,3.79-1.63a90.35,90.35,0,0,0,13.32-7.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.72,429.39l1-.47c.57-.26,1.14-.52,1.69-.79l1.66-.81,1.62-.83,1.58-.86c.52-.29,1-.58,1.55-.88s1-.6,1.52-.91,1-.61,1.48-.93,1-.63,1.44-1l1.42-1,1.37-1",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.52,419.2a1.61,1.61,0,0,1,.4.38.73.73,0,0,1,.18.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567,493.94l.18-.1c2.26-1.26,4.4-2.57,6.43-3.95",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.1,420c18-13.58,36.71-26.91,56.62-40.62",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.41,463.31q8-5.44,16.06-10.91l17.42-11.85,33.44-22.78",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.18,451a3.42,3.42,0,0,1,.36-1.41,2.8,2.8,0,0,1,.85-1.06",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.61,489.89q27.79-18.88,55.55-37.8",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.16,452.09a.64.64,0,0,1,0,.2.31.31,0,0,1-.1.15l0,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672,396.2Q656.16,407,640.33,417.77",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.62,434.71a.76.76,0,0,1,.86-.11,1.06,1.06,0,0,1,.38.9",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.57,413q-17.33,11.83-34.68,23.66",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.31,437a.7.7,0,0,0,.19.06.47.47,0,0,0,.17,0,.3.3,0,0,0,.13-.09.33.33,0,0,0,.07-.16.32.32,0,0,0,0-.14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.55,
    y1: 454.55,
    x2: 626.96,
    y2: 453.84,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.44,
    y1: 490.26,
    x2: 628.98,
    y2: 452.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 609.68,
    y1: 467.36,
    x2: 573,
    y2: 492.36,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 687.45,
    y1: 414.37,
    x2: 651.29,
    y2: 439.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.55,
    y1: 437.31,
    x2: 647.1,
    y2: 437.11,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.55,
    y1: 437.31,
    x2: 649.33,
    y2: 436.09,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573,
    y1: 492.36,
    x2: 572.64,
    y2: 500.79,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.46,
    y1: 454.57,
    x2: 612.74,
    y2: 465.28,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 630.97,
    y1: 456.25,
    x2: 628.64,
    y2: 454.82,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.4,
    y1: 445.6,
    x2: 632,
    y2: 456.09,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 651.07,
    y1: 439.53,
    x2: 648.49,
    y2: 444.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "588.81 514.09 589.06 513.91 589.07 513.91 627.03 488.04 629.93 486.06 634.3 483.08 637.2 481.11 661.8 464.34 664.58 462.45 683.71 449.41 685.89 447.93 696.89 440.44 696.89 440.43",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 651.13,
    y1: 439.36,
    x2: 651.13,
    y2: 439.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.6,
    y1: 454.66,
    x2: 628.6,
    y2: 454.71,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.55,
    y1: 437.31,
    x2: 647.55,
    y2: 436.8,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 651.07,
    y1: 439.53,
    x2: 646.52,
    y2: 437.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 651.13,
    y1: 439.31,
    x2: 646.74,
    y2: 437.35,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.1,
    y1: 419.96,
    x2: 573.41,
    y2: 463.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.61,
    y1: 489.89,
    x2: 573.41,
    y2: 463.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 648.88,
    y1: 435.89,
    x2: 651.31,
    y2: 436.97,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.33,
    y1: 417.77,
    x2: 640.06,
    y2: 380.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.51,
    y1: 441.6,
    x2: 640.33,
    y2: 417.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 630.39,
    y1: 448.49,
    x2: 640.51,
    y2: 441.6,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 629.16,
    y1: 452.09,
    x2: 629.18,
    y2: 450.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.51,
    y1: 441.6,
    x2: 650.62,
    y2: 434.71,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 651.86,
    y1: 435.5,
    x2: 651.89,
    y2: 436.61,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.07,
    y1: 437.13,
    x2: 651.29,
    y2: 439.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.46,
    y1: 454.57,
    x2: 626.9,
    y2: 453.87,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.57,
    y1: 454.56,
    x2: 632,
    y2: 456.09,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.4,
    y1: 445.6,
    x2: 639.69,
    y2: 442.16,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 641.26,
    y1: 441.09,
    x2: 648.49,
    y2: 444.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 651.86,
    y1: 435.5,
    x2: 650.41,
    y2: 434.85,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,456.25a1,1,0,0,0,1-.16",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.4,445.6a3.67,3.67,0,0,0,1.09-1.29",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.29,439a.43.43,0,0,0-.16.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.07,439.53a.49.49,0,0,0,.06-.17",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.6,454.71a.12.12,0,0,0,0,.11",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.44,490.27a.46.46,0,0,0,.17-.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.09,465c.5,2.87-.53,3.78-1.25,4.27-1,.64-2.25-.26-2.53-1.69",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 610.48,
    cy: 466.89,
    rx: 9.43,
    ry: 11.72,
    style: {
      fill: "none",
      stroke: "#f26850",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      strokeDasharray: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.79,451.52v1.29a73.21,73.21,0,0,1-2.11,16.26l-.06.21c-.44,1.68-.88,3.26-1.41,4.85-.75,2.21-1.59,4.38-2.53,6.49l-.18.4c-.1.23-.2.46-.31.69a73.33,73.33,0,0,1-22,27.33c-1.11.92-2.3,1.75-3.49,2.57a71.85,71.85,0,0,1-24.81,10.57c-1.11.18-2.3.46-3.49.64l-4.32.55c-1.47.19-2.85.28-4.32.37-1.1.09-2.21.09-3.31.09a69.85,69.85,0,0,1-12.5-1.1,45,45,0,0,1-5.14-1.1c-1.47-.37-2.94-.83-4.41-1.29-2.21-.73-4.5-1.56-6.62-2.48-1.74-.83-3.49-1.65-5.23-2.57-.84-.45-1.69-.9-2.51-1.38h0c-.52-.29-1-.6-1.53-.92a72,72,0,0,1-14.89-12.2,68.51,68.51,0,0,1-4.54-5.37c-.33-.43-.66-.87-1-1.31a1,1,0,0,1-.12-.17,71.68,71.68,0,0,1-10.69-21.59c-.21-.71-.42-1.43-.61-2.15a68.8,68.8,0,0,1-1.56-7.34,73,73,0,0,1-.88-11.34,72.2,72.2,0,0,1,2.11-17.39q.58-2.4,1.35-4.74c.13-.42.27-.84.41-1.26a72.35,72.35,0,0,1,37.43-41.93,70.88,70.88,0,0,1,13-4.69,24.66,24.66,0,0,1,3.5-.83,67.73,67.73,0,0,1,14.33-1.47c1,0,1.93,0,2.89.06l1.44.07a73.07,73.07,0,0,1,10.34,1.36q2.57.53,5.06,1.23A72.45,72.45,0,0,1,672,396.2c.92.77,1.81,1.56,2.69,2.37,1.46,1.36,2.86,2.79,4.2,4.26.71.78,1.42,1.57,2.06,2.35l.33.4a73,73,0,0,1,5.32,7.37l.12.18c.25.41.51.82.76,1.24a72.31,72.31,0,0,1,9.44,26.06h0c.19,1.19.34,2.4.47,3.61.17,1.57.28,3.14.34,4.72C697.79,449.69,697.79,450.6,697.79,451.52Z",
    style: {
      fill: "none",
      stroke: "#f26850",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671.61 462.43 653.01 462.43 653.01 452.82 629.2 466.56 653.01 480.31 653.01 470.7 671.61 470.7 671.61 462.43",
    style: {
      fill: "#f26850"
    }
  }, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_remote_go_in",
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "-20 0",
    begin: "0.5s;hinava_random_uuid_remote_blink.end+1s",
    dur: "1.5s",
    fill: "freeze"
  })), _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_remote_go_out",
    attributeName: "transform",
    type: "translate",
    from: "-20 0",
    to: "0 0",
    begin: "hinava_random_uuid_remote_go_in.end+1s",
    dur: "1s",
    fill: "freeze"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemote);
export default __webpack_public_path__ + "static/media/remote.18186a5e9997da7ba5a16cd15759cdd4.svg";
export { ForwardRef as ReactComponent };